import { theme } from '$theme';
import styled from '@emotion/styled';

export const StyledSpecificationWrapper = styled.div({
    position: 'relative',
});

export const StyledDownloadWrapper = styled.div({
    position: 'absolute',
    left: 'auto',
    top: '50%',
    marginLeft: theme.space[2],
    transform: 'translateY(-50%)',
    display: 'inline-block',
});

export const StyledDownload = styled.a({
    display: 'inline-flex',
    verticalAlign: 'middle',
});

export const HighlightsContent = styled.div({
    color: '#747474',
    padding: theme.space[4],
});

export const HighlightItem = styled.div({

    whiteSpace: 'pre-line',

    lineHeight: 1.5,

    marginBottom: theme.space[4],

    '& h2': {
        fontWeight: 'bold',
        marginTop: 0,
        marginBottom: theme.space[1],
        textTransform: 'uppercase'
    },

    '& h2.key-benefits-heading': {
        fontSize: '0.95rem',
        fontWeight: 'bold',
        marginTop: 40,
        marginBottom: theme.space[2],
    },

    '& p': {
        marginTop: 0,
        marginBottom: theme.space[1],
    },

    '& li': {
        marginBottom: theme.space[1],
    },
});

export const ReadMoreButton = styled.button({
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.space[2],
    padding: 0,
    border: 0,
    background: 'transparent',
    color: 'inherit',
    font: 'inherit',
    cursor: 'pointer',

    '&:hover': {
        textDecoration: 'underline',
    },

    '& .chevron': {
        display: 'inline-block',
        flexShrink: 0,
        width: '7px',
        height: '7px',
        borderRight: '1.5px solid currentColor',
        borderBottom: '1.5px solid currentColor',
        transform: 'translateY(-2px) rotate(45deg)',
        transition: 'transform 150ms ease',
    },

    '& .chevron-up': {
        transform: 'translateY(2px) rotate(225deg)',
    },
});